<div mat-dialog-title class="title-row">
    <span>Reklamationen bearbeiten</span>
    <button
        *ngIf="canCreateTierreklamation"
        mat-icon-button
        color="accent"
        (click)="openCreateTierreklamationDialog()"
        [disabled]="isCreating"
        matTooltip="Tierreklamation anlegen"
    >
        <mat-icon>add</mat-icon>
    </button>
</div>
<div mat-dialog-content class="reklamation-dialog-content">
    <p class="reklamation-empty" *ngIf="tierreklamationen?.length == 0">Keine Reklamationen gefunden!</p>
    <div *ngIf="tierreklamationen?.length > 0" class="reklamation-list-wrap">
        <ul class="reklamation-list">
            <li *ngFor="let t of tierreklamationen; let i = index" class="reklamation-list-item">
                <mat-checkbox (change)="addRemoveReklamation($event, t)" [checked]="isChecked(t)">
                    {{ t.reklamation }}
                </mat-checkbox>
            </li>
        </ul>
    </div>
</div>
<div mat-dialog-actions class="reklamation-dialog-actions">
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Speichern</button>
</div>
